import { render, staticRenderFns } from "./Internal-Invoice.vue?vue&type=template&id=463ce700"
import script from "./Internal-Invoice.vue?vue&type=script&lang=js"
export * from "./Internal-Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports